var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7394_31431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 4.2259C6.6116 4.59133 4.59084 6.61209 4.22542 9.16683H5.83301V10.8335H4.22542C4.59084 13.3882 6.6116 15.409 9.16634 15.7744V14.1668H10.833V15.7744C13.3878 15.409 15.4085 13.3882 15.7739 10.8335H14.1663V9.16683H15.7739C15.4085 6.61209 13.3878 4.59133 10.833 4.2259V5.8335H9.16634V4.2259ZM2.54545 9.16683C2.92974 5.69048 5.68999 2.93023 9.16634 2.54594V0.833496H10.833V2.54594C14.3093 2.93023 17.0696 5.69048 17.4539 9.16683H19.1663V10.8335H17.4539C17.0696 14.3098 14.3093 17.0701 10.833 17.4544V19.1668H9.16634V17.4544C5.68999 17.0701 2.92974 14.3098 2.54545 10.8335H0.833008V9.16683H2.54545ZM12.4997 10.0002C12.4997 11.3809 11.3804 12.5002 9.99967 12.5002C8.61892 12.5002 7.49967 11.3809 7.49967 10.0002C7.49967 8.61941 8.61892 7.50016 9.99967 7.50016C11.3804 7.50016 12.4997 8.61941 12.4997 10.0002Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7394_31431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.6797de8770d0db625828764eb9d9a879.svg";
export { ForwardRef as ReactComponent };